import { render } from "./DigitalMarketing.vue?vue&type=template&id=a4cd3b3c&scoped=true"
import script from "./DigitalMarketing.vue?vue&type=script&lang=js"
export * from "./DigitalMarketing.vue?vue&type=script&lang=js"

import "./DigitalMarketing.vue?vue&type=style&index=0&id=a4cd3b3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4cd3b3c"]])

export default __exports__